<template>
    <div>
        <h3 class="mb-0">{{ $t('descuentos_sga.titulo_cupon') }}</h3>
        <small>{{ $t('descuentos_sga.explicacion_cupon') }}</small>
        <div v-if="!estadoAplicado || !estadoValido" class="input-group mt-2 mb-2">
            <input
                class="form-control"
                id="input-cupon"
                v-model="cupon"
                :placeholder="$t('formularios.cupon_descuento')"
                :disabled="loading || loading_cupon"
            />
            <button
                :disabled="loading || loading_cupon || !cupon"
                :class="'button '+ (esMovil ? 'small-button' : 'large-button')"
                @click="handleCupon"
            >
                {{ $t('formularios.verificar') }}
            </button>
        </div>
        <div v-if="estadoAplicado" class="mt-2 mb-2">
            <b-row>
                <b-col cols="12" md="8">
                    <div v-if="estadoValido" class="alert alert-success d-flex justify-content-between align-items-center">
                        <div>
                            <i class="fas fa-ticket-alt"></i> &nbsp;
                            <strong>{{ cupon.toUpperCase() }}</strong>
                        </div>
                        <div>
                            <button
                                class="button badge bg-light text-danger py-2"
                                @click="desactivarCupon"
                                :disabled="loading || loading_cupon"
                            >
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                    <div v-else class="mt-2 mb-2">
                        <div class="alert alert-danger d-flex justify-content-between align-items-center">
                            <b>{{ estadoMensaje }}</b>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cart_id: {
                type: [String, Number],
                required: true
            },
            loading: {
                type: Boolean,
                required: true
            },
            esMovil: {
                type: Boolean,
                required: false,
                default: false
            },
            // Estado CONTROLADO desde el padre (única fuente de verdad):
            // cuando `aplicado` no es null, este componente NO verifica ni
            // pinta nada por su cuenta: solo emite `verificar` / `quitar` y
            // el estado visual llega por props (confirmado por el composable
            // contra el backend).
            aplicado: {
                type: Boolean,
                default: null
            },
            valido: {
                type: Boolean,
                default: null
            },
            mensajeExterno: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                cupon: '',
                mensaje: '',
                loading_cupon: false,
                cupon_aplicado: false,
                cupon_valido: false
            }
        },
        computed: {
            esControlado() {
                return this.aplicado !== null;
            },
            estadoAplicado() {
                return this.esControlado ? this.aplicado : this.cupon_aplicado;
            },
            estadoValido() {
                return this.esControlado ? this.valido : this.cupon_valido;
            },
            estadoMensaje() {
                return this.esControlado ? (this.mensajeExterno || '') : this.mensaje;
            }
        },
        methods: {
            async handleCupon() {
                if (this.esControlado) {
                    // Intención semántica: el padre verifica y aplica contra el
                    // backend, y solo entonces actualiza `aplicado`/`valido`.
                    if (!this.cupon || this.loading) return;
                    this.$emit('verificar', this.cupon);
                    return;
                }
                this.loading_cupon = true;
                this.mensaje = '';

                const params = {
                    filters: {
                        codigo: this.cupon
                    },
                    cart_id: this.cart_id
                };

                try {
                    // Se espera la petición: loading_cupon cubre toda la
                    // operación (sin clics concurrentes) y el estado visual
                    // solo se actualiza al terminar.
                    const res = await this.$store.dispatch(this.config.getVuexAlias('sga.cart.descuentos-codigo'), params);
                    if (res.data?.data?.limit === 0 || res.data?.data?.availableUses === 0) {
                        this.cupon_aplicado = true;
                        this.cupon_valido = false;
                        this.mensaje = 'Cupón de descuento no disponible';
                    } else if (!res.data.data) {
                        this.cupon_aplicado = true;
                        this.cupon_valido = false;
                        this.mensaje = 'El cupón introducido no existe o no está disponible';
                    } else {
                        this.cupon_aplicado = true;
                        this.cupon_valido = true;
                        this.$emit('setDescuento', res.data.data);
                        this.mensaje = '¡Cupón de descuento aplicado correctamente!';
                    }
                } catch (error) {
                    // El error también activa el bloque visual del cupón:
                    // sin `cupon_aplicado`, el mensaje no se renderiza.
                    this.cupon_aplicado = true;
                    this.cupon_valido = false;
                    this.mensaje = 'El cupón introducido no existe o no está disponible';
                } finally {
                    this.loading_cupon = false;
                }
            },
            desactivarCupon() {
                this.cupon = '';
                if (this.esControlado) {
                    this.$emit('quitar');
                    return;
                }
                this.cupon_aplicado = false;
                this.$emit('desactivarCuponGeneral', null);
            }
        }
    }
</script>
